module.exports = __webpack_public_path__ + "img/img9697_title6.b81b055d.jpg";